function shortDateFormat(date, sDelimiter) {

    if (!date) {
        return "";
    }

    if (Object.prototype.toString.call(date) === "[object Date]") {
        if (isNaN(date.getTime())) {
            return "";
        }
    }

    let d = new Date(date);

    if (sDelimiter === undefined) {
        sDelimiter = "&nbsp;";
    }

    let year = d.getFullYear().toString();

    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    let day = d.getDate() < 10
        ? "0" + d.getDate().toString()
        : d.getDate().toString();

    return year + sDelimiter + monthNames[d.getMonth()] + sDelimiter + day;
}


function timeFormat(date) {

    if (!date) {
        return "";
    }

    if (Object.prototype.toString.call(date) === "[object Date]") {
        if (isNaN(date.getTime())) {
            return "";
        }
    }

    let d = new Date(date);

    let sHour = d.getHours().toString();
    let minute = d.getMinutes();

    let sMinute = minute.toString();
    if (minute < 10) {
        sMinute = "0" + sMinute;
    }

    return sHour + ":" + sMinute;
}


function timeFormatAMPM(date, suppressMidnight) {

    if (!date) {
        return "";
    }

    if (Object.prototype.toString.call(date) === "[object Date]") {
        if (isNaN(date.getTime())) {
            return "";
        }
    }

    let d = new Date(date);

    let hour = d.getHours();
    let minute = d.getMinutes();

    if (hour === 0 && minute === 0 && suppressMidnight) {
        return "";
    }

    let sMinute = minute.toString();
    if (minute < 10) {
        sMinute = "0" + sMinute;
    }

    if (hour === 0) {
        return `12:${sMinute} AM`;
    }
    else if (hour < 12) {
        return `${hour}:${sMinute} AM`;
    } else if (hour === 12) {
        return `12:${sMinute} PM`;
    } else {
        return `${hour - 12}:${sMinute} PM`;
    }
}


export { shortDateFormat, timeFormat, timeFormatAMPM };